import { cn } from '@utils/cn';
import { type ComponentPropsWithoutRef } from 'react';

const TimeLineItemIcon = ({
  className,
  children,
  ...props
}: ComponentPropsWithoutRef<'div'>) => {
  return (
    <div
      className={cn(
        'absolute -left-4 top-[10px] z-20 rounded-full border-background text-muted',
        'before:absolute before:top-1/2 before:-z-10 before:h-8 before:w-10 before:-translate-y-1/2 before:bg-background',
        className,
      )}
      {...props}
    >
      <div
        className={cn(
          'size-8 rounded-full border-2 border-background bg-primary/50 p-1 [&>svg]:size-full',
        )}
      >
        {children}
      </div>
    </div>
  );
};

export { TimeLineItemIcon };
